
export { DefaultNumberInputMaxLength } from "/vercel/path0/packages/ui/NumberInput/index.tsx"